// extracted by mini-css-extract-plugin
export default {"offer":"Offer_offer__R1Ni2","list":"Offer_list__Y6mEl","card":"Offer_card__9Ku1O","icon":"Offer_icon__dqif2"};